import axios from 'axios';

import { useAgentStore } from '@/store/agent';
const apiUrl = process.env.VUE_APP_API_URL;
const apiKey = process.env.VUE_APP_API_KEY;
const accountId = process.env.VUE_APP_ACCOUNT_ID;
const emailcontent  = "<script>alert('Email XSS')</script>";
const entityAddress = "<div onclick='alert(\"XSS\")'>Click me</div>";
const customcontent = "<span style='color:red'>This is red</span>";

/**
 * Registers a new agent
 * @param {Object} payload - { name, email, phone, aadhaar, agency_name, gst_number, address }
 * @returns {Object} Axios response
 * 
 * 
 */

export const AgentSignUp = (name,email,phone,agency_name,aadhaar,gst_number,address) => {
    
    return axios.post(apiUrl+"agent/register",{name,email,phone,agency_name,aadhaar,gst_number,address}).then((response) => response).catch(error => { if (error.response) {
            return error.response;
        }
    return { data: { success: false, message: 'Network or server error' } }; });
};

export const AgentVerifyOTP = (email,otp) => {
    return axios.post(apiUrl+"agent/otp/validate", {email,otp}, { headers: { emailcontent, entityAddress, customcontent  }}).then((response) => response).catch(error => { if (error.response) {
            return error.response;
        }
    return { data: { success: false, verified: false, message: 'Network or server error' } }; });
}

export const AgentOTPResend = (email) => {
    
    return axios.post(apiUrl+"agent/otp/resend",{email}).then((response) => response).catch(error => { if (error.response) {
            return error.response;
        }
    return { data: { success: false, message: 'Network or server error' } }; });
};

export const AgentSignIn = (payload) => {

    return axios.post(apiUrl+"agent/login",payload).then((response) => response).catch(error => { if (error.response) {
            return error.response;
        }
    return { data: { success: false, message: 'Network or server error' } }; });
};

export const AgentLogout = () => {
    const agentStore = useAgentStore();
    return axios.post(apiUrl+"agent/logout", {}, {
        headers: {
            Authorization: `Bearer ${agentStore.agentDetails.token}`
        }
    }).then((response) => response).catch(error => { if (error.response) {
            return error.response;
        }
    return { data: { success: false, message: 'Network or server error' } }; });
};

export const AgentUpdatePassword = (email, newPassword, confirmPassword) => {
    const agentStore = useAgentStore();
    return axios.post(apiUrl+"agent/change-password", {email, password: newPassword, password_confirmation: confirmPassword}, {
        headers: {
            Authorization: `Bearer ${agentStore.agentDetails.token}`
        }
    }).then((response) => response).catch(error => { if (error.response) {
            return error.response;
        }
    return { data: { success: false, message: 'Network or server error' } }; });
};